import React from "react";
import "./CorePlatform.css";

import LanguageIcon from "@mui/icons-material/Language";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import BarChartIcon from "@mui/icons-material/BarChart";
import StarBorderIcon from "@mui/icons-material/StarBorder";

const features = [
    {
        title: "Strong Digital Presence",
        points: [
            "Online storefront",
            "Marketplace visibility",
            "Reach nearby customers",
        ],
        icon: <LanguageIcon />,
    },
    {
        title: "Better Profit Control",
        points: [
            "Track sales clearly",
            "Control costs",
            "Smart reporting",
        ],
        icon: <TrendingUpIcon />,
    },
    {
        title: "Business Growth Insights",
        points: [
            "Data dashboards",
            "Reports & trends",
            "Performance tracking",
        ],
        icon: <BarChartIcon />,
    },
    {
        title: "Customer Experience",
        points: [
            "Fast billing",
            "Live order updates",
            "Ratings & feedback",
        ],
        icon: <StarBorderIcon />,
    },
];

export default function CorePlatform() {
    return (
        <div className="core-section">
            <div className="core-container">
                <h2 className="core-title">
                    Why Choose <span>MAAMAAS</span>
                </h2>

                <p className="core-subtitle">
                    Everything you need to digitize and grow your food business.
                </p>

                <div className="core-grid">
                    {features.map((item, index) => (
                        <div className="core-card" key={index}>
                            <div className="core-icon">{item.icon}</div>
                            <h3>{item.title}</h3>
                            <ul>
                                {item.points.map((point, i) => (
                                    <li key={i}>{point}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}